import React, { useState } from "react";
import DOMPurify from "dompurify";
import { Container, Row, Col, Button } from "react-bootstrap";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { jobsDesc } from "../../StaticData/applytojob";
import { Helmet } from "react-helmet";
import "../../pages/Careers/Careers.css";

const JobDesc = () => {
  const jobPathName = window.location.pathname;
  const [job] = useState(jobsDesc.find((job) => job.link === jobPathName));

  return (
    <div className="jobdesc-page">
      <Helmet>
        <title>{job?.jobtitle ? `${job.jobtitle} | Idexcel` : "Job Details | Idexcel"}</title>
        <meta
          content="current openings usa, current openings india"
          name="keywords"
        />
        <meta
          content="Ready to explore a career with Idexcel? Click here and explore our job openings."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <section className="insights-sections">
          <Container className="h-100">
            <Row className="h-100 align-items-center">
              <Col lg={9}>
                <div className="content">
                  <motion.div
                    className="Productleft"
                    initial={{ opacity: 0, x: -50 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true, amount: 0.7 }}
                  >
                    <h1 className="text-white">{job && job?.jobtitle}</h1>
                    <p className="text-white"> Bengaluru</p>
                    {/* Display the job title */}
                  </motion.div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </motion.div>

      <Container className="job-description">
        <section
          className="col-xl-8 col-12 py-5"
          style={{ textAlign: "justify" }}
        >
          {/* Display job intro if available */}
          {job?.jobIntro && (
            <div style={{ fontSize: "22px", marginBottom: "30px" }}>
              {typeof job.jobIntro === 'string' ? (
                <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.jobIntro) }} />
              ) : (
                job.jobIntro.map((point) => {
                  const isSubheading = point.trim().endsWith(':') && point.length < 50;
                  const isSubBullet = point.trim().startsWith('➤') || point.trim().startsWith('·') || point.trim().startsWith('•');
                  const key = point + Math.random();
                  if (isSubheading) {
                    return <h5 key={key} style={{ marginTop: '20px', marginBottom: '10px', fontWeight: 'bold' }}>{point}</h5>;
                  } else if (isSubBullet) {
                    return <div key={key} style={{ marginLeft: '40px', marginBottom: '8px' }}>{point}</div>;
                  } else {
                    return <ul key={key} style={{ marginBottom: '8px' }}><li>{point}</li></ul>;
                  }
                })
              )}
            </div>
          )}

          {job?.jobDescHeading !== "" && (
            <h3>{job?.jobDescHeading || "Required Skills & Experience:"}</h3>
          )}
          {job?.jobDescSubHeading && (
            <h4 style={{ marginTop: "20px", marginBottom: "15px" }}>{job.jobDescSubHeading}</h4>
          )}
          <div style={{ fontSize: "22px", marginBottom: "30px" }}>
            {/* Map through the jobdesc array and display each item */}
            {job?.jobdesc?.map((point) => {
              const isSubheading = point.trim().endsWith(':') && point.length < 50;
              const isSubBullet = point.trim().startsWith('➢') || point.trim().startsWith('•');
              const key = point + Math.random();
              if (isSubheading) {
                return <h5 key={key} style={{ marginTop: '20px', marginBottom: '10px', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(point) }} />;
              } else if (isSubBullet) {
                return <div key={key} style={{ marginLeft: '40px', marginBottom: '8px' }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(point) }} />;
              } else {
                return <ul key={key} style={{ marginBottom: '8px' }}><li dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(point) }} /></ul>;
              }
            })}
          </div>

          <h3>Company Profile </h3>
          <p>
            Idexcel is a Professional Services and Technology Solutions provider specializing in&nbsp;
            <a href="/gen-ai-banking">AI Banking</a>,&nbsp;
            <a href="/enterprise-ai">Enterprise AI</a>,&nbsp;
            <a href="/data-analytics">Data & Analytics</a>,&nbsp;
            <a href="/next-gen-modernization">Next-Gen Modernization</a>,&nbsp;
            <a href="/cloud-innovations">Cloud Innovations</a>, and&nbsp;
            <a href="/managed-cybersecurity">Managed Cybersecurity</a>.
            Idexcel is an Amazon Web Services (AWS) Advanced Tier Services Partner. We are proud that for more than 20 years we have delivered innovative, agile, and successful technology solutions that provide our customers with lasting value.
          </p>


          <p>
            Our name, "Idexcel" is a representation of our core principle "Ideas to Excellence". We are relentlessly driven by results and take pride in our customer-centric engagement models. We blend our clients’ needs with proven delivery models and highly talented execution teams to deliver an exceptional customer experience.
          </p>
          <p>
            Headquartered in Herndon, Virginia, Idexcel has offices and delivery locations in the US, Europe and Asia supporting global clients.
          </p>
          <div className="d-flex flex-row align-items-center">
            <a href="/careers/apply-to-job" className="button mt-5 ">
              Apply Now
            </a>
          </div>
        </section>
      </Container>
    </div>
  );
};

export default JobDesc;
